//@flow
import React, { useState } from 'react';
import { CallToAction } from 'components/atoms/callToAction';
import { ShareButton } from 'components/atoms/shareButton';
import { PaginationControl } from 'components/molecules/paginationControl';
import './styles.scss';
import type { ConstructionGalleryType } from 'types/project';
import HorizontalCarouselStatements from 'components/atoms/horizontalCarouselStatements';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';

type Props = {
  // onClick: void,
  constructionGalleryData: Object<ConstructionGalleryType>,
  displayHeader?: boolean,
};

export const ConstructionGalleryCard = (props: Props) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [slider, setSlider] = useState(null);
  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const {
    constructionGalleryData: {
      constructionGalleryIntro,
      constructionGalleryList,
    },
    displayHeader,
  } = props;

  const lengthOfSlider = constructionGalleryList
    ? constructionGalleryList.length
    : 0;

  if (!constructionGalleryIntro && !constructionGalleryList) {
    return null;
  }

  // Render Footer
  const next = () => {
    slider.slickNext();
  };

  const previous = () => {
    slider.slickPrev();
  };

  const renderFooter = () => {
    // TODO Check random value for KEY.
    return (
      <div className="section-footer">
        <PaginationControl
          className={'section-footer-item'}
          theme={'light-theme'}
          mode={'slider'}
          currentIndex={activeSlide + 1}
          total={lengthOfSlider}
          onNextClick={next}
          onPreviousClick={previous}
          key={'10'}
        />
      </div>
    );
  };

  // Render Content
  const renderIntro = () => {
    return (
      <div className={'construction-gallery-intro-card'}>
        <HorizontalCarouselStatements
          heading={constructionGalleryIntro.projectName}
          subHeading={constructionGalleryIntro.galleryHeading}
          description={constructionGalleryIntro.galleryDescription}
        />
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={'construction-gallery-card'}>
        {renderIntro()}
        <div className={'construction-gallery-carousel'}>
          <HorizontalCarousel
            data={constructionGalleryList}
            cssFor={'construction-gallery'}
            type={'construction-gallery'}
            getActiveSlide={e => {
              setActiveSlide(e);
            }}
            handleSliderRef={handleSliderRef}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={'construction-gallery-container section-container'}>
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
